<template>
  <div class="chatSpin-wrapper" :style="{height:height + 'px',width:width,background:bgColor}">
    <a-spin class="topchatSpin" :size="size" :tip="tip" />
  </div> 
</template>

<script>
export default {
    name:'chatSpin',
    props:{
       width:{
        type:String,
        default:'100%'
       },
       height:{
        type:String,
        default:'100'
       },
       bgColor:{
        type:String,
        default:'transparent'
       },
        // 组件大小
        size:{
          // small default large
          type:String,
          default:'default'
        },
        // 自定义文案
        tip:{
          type:String,
        }
    },
    data(){
      return{
        
      }
    }

}
</script>

<style lang="less">
.chatSpin-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  .topchatSpin .ant-spin-dot-spin .ant-spin-dot-item{
    background-color: #74eafe;
  }
}

</style>